import { H5JumpApp } from '@/core/bridge'
import { getRandomRoomId } from '@/service/newindex'
import { RoomLink } from '@/state/const'
import client from '@/utils/client'
import { user } from '@/state/user'
import { trackEvent } from '@/utils/tracking_utils'

export const useClientCommonUtils = () => {
  const toSend = async (props: any, scene?: string, params?: any) => {
    const res = await getRandomRoomId()
    if (res.data?.room_id) {
      const roomId = res.data.room_id
      if (props.tabId && props.giftId) {
        H5JumpApp(RoomLink + roomId + `&giftTabId=${props.tabId}&giftId=${props.giftId}`)
      } else if (props.tabId) {
        H5JumpApp(RoomLink + roomId + `&giftTabId=${props.tabId}`)
      } else {
        H5JumpApp(RoomLink + roomId)
      }

      if (scene) {
        trackEvent(user, scene, params)
      }
    } else if (res.msg) {
      client.toast(res.msg)
    }
  }

  const toRecharge = () => {
    H5JumpApp('hifun://page/charge')
  }

  const toRandomRoom = async (giftConfig?: string) => {
    const res = await getRandomRoomId()
    if (res.data?.room_id) {
      const roomId = res.data.room_id
      H5JumpApp(RoomLink + roomId + (giftConfig || ''))
    }
  }

  return {
    toSend,
    toRecharge,
    toRandomRoom,
  }
}
